export var getFirstAdvantageText = function getFirstAdvantageText(isSelfEmployedInfo) {
  if (isSelfEmployedInfo) {
    return 'Если вы — самозанятый, перейдите на сайт нашего партнёра и зарегистрируйтесь. \nЕсли нет, то пока вы не сможете участвовать в программе.';
  }
  return 'Перейдите на сайт нашего партнёра и зарегистрируйтесь в программе.';
};